module.exports = __webpack_public_path__ + "img/mgs.c1d459ed.png";